import { render, staticRenderFns } from "./Escandallos.vue?vue&type=template&id=27933ca8&"
import script from "./Escandallos.vue?vue&type=script&lang=js&"
export * from "./Escandallos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports